import actions from '../actions';

const initialState = {
    fetching: false,
    fetched: false,
    fetchFailed: false,
    enterprisesList: []
}
export default function enterprises(state = initialState, action) {
    switch(action.type) {
        case actions.GET_ENTERPRISES_REQUEST:
            return Object.assign({}, state, {
                fetching: true, fetched: false, fetchFailed: false,
                statusText: null
            });
        case actions.GET_ENTERPRISES_SUCCESS:
            return Object.assign({}, state, {
                fetching: false, fetched: true, fetchFailed: false,
                enterprisesList: action.enterprises
            });
        case actions.GET_ENTERPRISES_FAILED:
            return Object.assign({}, state, {
                fetching: false, fetched: false, fetchFailed: true,
                statusText: action.errorMessage
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/enterprisesReducer.js